import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { CBRetentionLogo } from '@bbkAdminComponents/cbretention-logo';

export const AuthPanel: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div
      className={cs(
        'tw-mx-auto tw-mt-24 tw-w-[530px] tw-px-10 tw-py-10',
        'tw-rounded-md tw-border tw-border-cbrneutral-200 tw-bg-white'
      )}
    >
      <CBRetentionLogo className="tw-mb-6 tw-h-10" />
      {children}
    </div>
  );
};
